module.exports = __webpack_public_path__ + "img/sms.e31f375f.svg";